<template>
<div class="chapter">
<div class="inner_page">
<h1>The Negro in the American</h1>
<h2 class="sigil_not_in_toc">Rebellion His Heroism</h2>
<h2 class="sigil_not_in_toc">And His Fidelity</h2>
<h3 class="sigil_not_in_toc">William Wells Brown</h3>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?8a43f0a6